@switch (slot().type) {
    @case (slotType.NumericStepperSlot) {
        <ca-slot-numeric-stepper
            [attr.data-testid]="'slot-' + slotIndex() + '-' + questionBlockId()"
            [form]="form()"
            [markAsTouched]="markAsTouched()"
            [slot]="slot()"
            [slotIndex]="slotIndex()"
            [questionBlockId]="questionBlockId()"
            [questionBlockValidations]="questionBlockValidations()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="valueChange.emit($event)"
        ></ca-slot-numeric-stepper>
    }
    @case (slotType.CheckboxInlineSlot) {
        <ca-slot-inline-checkbox
            [attr.data-testid]="'slot-' + slotIndex() + '-' + questionBlockId()"
            [slot]="slot()"
            [form]="form()"
            [markAsTouched]="markAsTouched()"
            [slotIndex]="slotIndex()"
            [questionBlockId]="questionBlockId()"
            [questionBlockValidations]="questionBlockValidations()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="valueChange.emit($event)"
        >
        </ca-slot-inline-checkbox>
    }
    @case (slotType.CheckboxTileSlot) {
        <ca-slot-tile-checkbox
            [attr.data-testid]="'slot-' + slotIndex() + '-' + questionBlockId()"
            [form]="form()"
            [markAsTouched]="markAsTouched()"
            [slot]="slot()"
            [slotIndex]="slotIndex()"
            [questionBlockId]="questionBlockId()"
            [questionBlockValidations]="questionBlockValidations()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="valueChange.emit($event)"
        >
        </ca-slot-tile-checkbox>
    }
    @case (slotType.RadioButtonInlineSlot) {
        <ca-slot-inline-radio-button
            [attr.data-testid]="'slot-' + slotIndex() + '-' + questionBlockId()"
            [slot]="slot()"
            [form]="form()"
            [markAsTouched]="markAsTouched()"
            [slotIndex]="slotIndex()"
            [questionBlockId]="questionBlockId()"
            [questionBlockValidations]="questionBlockValidations()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="valueChange.emit($event)"
        >
        </ca-slot-inline-radio-button>
    }
    @case (slotType.RadioButtonTileSlot) {
        <ca-slot-tile-radio-button
            [attr.data-testid]="'slot-' + slotIndex() + '-' + questionBlockId()"
            [slot]="slot()"
            [form]="form()"
            [markAsTouched]="markAsTouched()"
            [slotIndex]="slotIndex()"
            [questionBlockId]="questionBlockId()"
            [questionBlockValidations]="questionBlockValidations()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="valueChange.emit($event)"
        >
        </ca-slot-tile-radio-button>
    }
    @case (slotType.NumericInputSlot) {
        <ca-slot-input
            [attr.data-testid]="'slot-' + slotIndex() + '-' + questionBlockId()"
            [slot]="slot()"
            [form]="form()"
            [markAsTouched]="markAsTouched()"
            [slotIndex]="slotIndex()"
            [questionBlockId]="questionBlockId()"
            [questionBlockValidations]="questionBlockValidations()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="valueChange.emit($event)"
        ></ca-slot-input>
    }
    @case (slotType.TextInputSlot) {
        <ca-slot-input
            [attr.data-testid]="'slot-' + slotIndex() + '-' + questionBlockId()"
            [slot]="slot()"
            [form]="form()"
            [markAsTouched]="markAsTouched()"
            [slotIndex]="slotIndex()"
            [questionBlockId]="questionBlockId()"
            [questionBlockValidations]="questionBlockValidations()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="valueChange.emit($event)"
        ></ca-slot-input>
    }
    @case (slotType.OptionalNumericInputTileSlot) {
        <ca-slot-tile-optional-input
            [attr.data-testid]="'slot-' + slotIndex() + '-' + questionBlockId()"
            [slot]="slot()"
            [form]="form()"
            [markAsTouched]="markAsTouched()"
            [slotIndex]="slotIndex()"
            [questionBlockId]="questionBlockId()"
            [questionBlockValidations]="questionBlockValidations()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="valueChange.emit($event)"
        ></ca-slot-tile-optional-input>
    }
    @case (slotType.OptionalTextInputTileSlot) {
        <ca-slot-tile-optional-input
            [attr.data-testid]="'slot-' + slotIndex() + '-' + questionBlockId()"
            [slot]="slot()"
            [form]="form()"
            [markAsTouched]="markAsTouched()"
            [slotIndex]="slotIndex()"
            [questionBlockId]="questionBlockId()"
            [questionBlockValidations]="questionBlockValidations()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="valueChange.emit($event)"
        ></ca-slot-tile-optional-input>
    }
    @case (slotType.DropdownSlot) {
        <ca-slot-dropdown
            [attr.data-testid]="'slot-' + slotIndex() + '-' + questionBlockId()"
            [slot]="slot()"
            [form]="form()"
            [markAsTouched]="markAsTouched()"
            [slotIndex]="slotIndex()"
            [questionBlockId]="questionBlockId()"
            [questionBlockValidations]="questionBlockValidations()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="valueChange.emit($event)"
        ></ca-slot-dropdown>
    }
    @case (slotType.MultiselectDropdownSlot) {
        <ca-slot-multiselect-dropdown
            [attr.data-testid]="'slot-' + slotIndex() + '-' + questionBlockId()"
            [slot]="slot()"
            [form]="form()"
            [markAsTouched]="markAsTouched()"
            [slotIndex]="slotIndex()"
            [questionBlockId]="questionBlockId()"
            [questionBlockValidations]="questionBlockValidations()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="valueChange.emit($event)"
        ></ca-slot-multiselect-dropdown>
    }
    @default {
        <div class="slot-unsupported">
            {{ 'COMMON.INFO.UNSUPPORTED_SLOT_TYPE' | translate: { slotType: slot().type } }}
        </div>
    }
}
